// extracted by mini-css-extract-plugin
export default {"errorLabel":"ErrorLabel_errorLabel__g5nLM"};